export default [
  {
    title: 'Privacy',
    paragraphs: [
      `At First Atlantic Bank PLC, and our affiliates and subsidiaries, our number one priority is our
      relationship with you. We value the faith you have shown in entrusting us with your financial
      affairs, and we are committed to protecting any personal information we maintain about you.`,

      `Establishing an effective Privacy Policy, designed to protect your information and provide you
      with choices on how you would like your information managed, is an important part of our
      relationship with you.`,
    ],
  },
  {
    title: 'Privacy Notice',
    paragraphs: [
      `Our Privacy Notice explains the type of information we may collect from our customers, the
      situations in which we may share information about them, and what they can do to limit the
      sharing of information.`,
    ],
  },
  {
    title: 'Online Privacy Practices',
    paragraphs: [
      `First Atlantic Bank PLC and our affiliates and subsidiaries value your trust and respect your
      expectation of privacy. As such, we are committed to maintaining the confidentiality of your
      personal financial information.`,

      `This document outlines our privacy practices for visitors to our website, regardless of the
      application used to establish the link, as well as for consumers who apply for or obtain services
      from us, such as loans, deposits, investments, insurance, or a safe deposit box. These practices
      apply to our family of companies, including First Atlantic Bank PLC, First Atlantic Asset
      Management, First Atlantic Brokerage.`,
    ],
  },
  {
    title: 'Visitors to Our Website',
    paragraphs: [
      `As a visitor to our website, you remain anonymous, unless you register for a service or
      otherwise choose to disclose your identity to us. Although we do not collect personal
      information that identifies people who simply visit our site, we may collect certain limited
      information about our visitors, such as their IP address (a numeric address assigned
      automatically to computers and mobile devices when they access the Internet).`,
    ],
  },
  {
    title: 'Cookies',
    paragraphs: [
      `We may place "cookies" on a computer or other device type to track a visitor's use of our site. A
      cookie is a piece of data that is stored on your hard drive. It takes up very little room on your
      system and helps us to customize our site and make its navigation easier for you. You can set
      your web browser to inform you when cookies are placed on your computer or to prevent them
      from being placed.`,

      `However, if you choose to prevent cookies from being placed, some of our 
      web banking functions may not work properly on your computer or mobile device. Unless you
      register with us for a service (such as our Online Banking service), the cookies do not provide us
      with any personally identifying information about you, such as your name, address or login
      information.`,

      `We use web analytics tools to collect anonymous information about pages visited, links that
      are clicked, and other information about the use of our website. We use this information in
      aggregate to better understand site activity, and to improve our products and services.`,
    ],
  },
  {
    title: 'Flash Shared Objects (also known as "flash cookies")',
    paragraphs: [
      `As part of our ongoing efforts to enhance our online security and protect your information,
      First Atlantic Bank PLC places flash shared objects on our online banking customers' PCs. This
      action assists you in conducting your online banking transactions. Please be aware that you
      can remove these flash shared objects. However, doing so may increase the likelihood that you
      will be prompted for additional forms of authentication during your online sessions.`,
    ],
  },
  {
    title: 'Web Browser \'Do Not Track\' Signals',
    paragraphs: [
      `This product facilitates export trade by providing liquidity to exporters with irrevocable letters
      of credit. Upon submission of shipping documents, exporters will receive immediate payment
      from the Bank which will reimburse itself when drawings are due.`,
    ],
  },
  {
    title: 'Links to Other Websites',
    paragraphs: [
      `Our website may feature links to third-party sites that offer goods, services, or information.
      Some of these sites may appear as "windows within windows" at our site. When you click on
      one of these links, you will leave our site and will no longer be subject to First Atlantic Bank PLC's
      Privacy Policy and privacy practices. We are not responsible for the information-collection
      practices of the other sites that you visit, and we urge you to review their privacy policies
      before you provide them with any personally identifiable information. Third-party sites may
      collect and use information about you in a way that is different from that of First Atlantic Bank PLC.`,
    ],
  },
  {
    title: 'Social Media',
    paragraphs: [
      `When you engage with First Atlantic Bank PLC on our official social media pages, you make certain
      information from your social media profile, postings, interactions, etc. available to First
      Atlantic Bank PLC and other participants in these platforms. You can control what data you share,
      and with whom, through the privacy settings on these social media sites. Any information you
      share or interaction you may have while participating is subject to the privacy policies and
      terms of use of those sites.`,
    ],
  },
  {
    title: 'Services and Advertisements by Third Parties',
    paragraphs: [
      `Third parties may offer services from time to time at our website. If you provide these third
      parties with information, their use of that information will be subject to their privacy policies, if
      any, and will not be subject to First Atlantic Bank PLC's policy. If you accept third-party goods or
      services advertised at our site, a third party may be able to determine that you have a
      relationship with us (for example, if the offer was made only through our site).`,

      `We may use third parties to provide services on our behalf, such as website analytics, hosting
      of microsites, or social media moderation services. These third parties are contractually
      obligated to comply with First Atlantic Bank PLC privacy and security standards and are limited in
      their use of any information collected on our behalf.`,
    ],
  },
  {
    title: 'Protecting Children',
    paragraphs: [
      `We feel strongly about protecting the privacy of children. As such, we do not knowingly collect
      personally identifiable information from children under the age of 13 through our site.`,
    ],
  },
  {
    title: 'Open Account Trading:',
    paragraphs: [
      `This allows an importer to make payment at some specific date in the future without any
      commitment such as a negotiable instrument evidencing his legal commitment to pay at the
      appointed time. This usually occurs in a buyers’ market and involves the fewest restriction and
      the least cost to the buyer. It also drives sales for the seller.`,
    ],
  },
  {
    title: 'Changes to This Information',
    paragraphs: [
      `We may amend (add to or change) this information from time to time by posting a notice of
      the change at this site. Your continued use of our site or any online service following
      notification will constitute your agreement to any changes.`,
    ],
  },
];
